import React from 'react';
import { default as RadioMaterial, RadioProps } from '@material-ui/core/Radio';
import { makeRadioClasses } from 'styles/components/radio';

const Radio: React.FC<RadioProps> = props => {
    const classes = makeRadioClasses();

    return <RadioMaterial classes={classes} {...props} />;
};

export default Radio;
